/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { MdAllOut, MdDashboard } from "react-icons/md";
// import {
//   ControllerAreaIcon,
//   RoutesIcon,
//   StoreIcon,
//   TeamIcon,
//   ConsignmentsIcon,
//   WorkLoadIcon,
// } from "assets/icons";
import {
  ArrowLeftRightIcon,
  Boxes,
  // ChevronsRight,
  LayoutDashboard,
  LucideBanknoteArrowUp,
} from "lucide-react";
import { Permissions } from "./enums";

export const API_URL = process.env.REACT_APP_API_URL;
export const CashierActionList = [
  {
    label: "Routes Management & Roster Generation",
    // icon: RoutesIcon,
    path: "/routes",
    permission: "",
  },
  {
    label: "Roster Management & Vans Issuance/Return",
    // icon: StoreIcon,
    path: "/store",
    permission: "",
  },
  // {
  //   label: "Team Management",
  //   // icon: TeamIcon,
  //   path: "/team-management",
  //   permission: "",
  // },
  {
    label: "Loading Bay Dispatching",
    // icon: ControllerAreaIcon,
    path: "/loading-bay-dispatch",
    permission: "",
  },
  {
    label: "Loading Bay Receiving",
    // icon: ControllerAreaIcon,
    path: "/loading-bay-receiving",
    permission: "",
  },
  {
    label: "Inter Branch Management",
    // icon: ControllerAreaIcon,
    path: "/inter-branch-management",
    permission: "",
  },
  {
    label: "Workload Automation",
    // icon: WorkLoadIcon,
    path: "/work-load-automation",
    permission: "",
  },
  {
    label: "Consignments Handover",
    // icon: ConsignmentsIcon,
    path: "/consignments-handover",
    permission: "",
  },
  {
    label: "Manage All Order",
    // icon: ConsignmentsIcon,
    path: "/manage-all-order",
    permission: "",
  },
  {
    label: "Search Order By Location",
    // icon: ConsignmentsIcon,
    path: "/orders-by-location",
    permission: "",
  },
  {
    label: "Package Life Cycle",
    // icon: ConsignmentsIcon,
    path: "/package-life-cycle",
    permission: "",
  },
  {
    label: "Search By Route",
    // icon: ConsignmentsIcon,
    path: "/orders-by-route",
    permission: "",
  },
  {
    label: "Re-Routing of Holding/Pending packages",
    // icon: ConsignmentsIcon,
    path: "/delivery-packages-verification",
    permission: "",
  },
  {
    label: "Direct Receiving & Handover",
    // icon: ConsignmentsIcon,
    path: "/split-route",
    permission: "",
  },
  {
    label: "Split Route Management",
    // icon: ConsignmentsIcon,
    path: "/split-route-management",
    permission: "",
  },
  {
    label: "Vans Insurance Limit",
    // icon: ConsignmentsIcon,
    path: "/vehicle-insurance-limit",
    permission: "",
  },
];

export const REQUIRED_ADDITIONAL_ITEMS = [
  "Pouch Bag",
  "Incoming Box Seal",
  "Outgoing Box Seal",
];

export const PROCESSING_TYPES = ["Desktop Processing", "Machine Processing"];

export const POUCH_BAG_DATA = [
  {
    label: "Enter Counter First Transaction",
    name: "firstTransaction",
  },
  {
    label: "Enter Counter Last Transaction",
    name: "lastTransaction",
  },
  {
    label: "Enter Capture Card as per Journal",
    name: "capturedCardsJournal",
  },
  {
    label: "Enter Actual Capture Card",
    name: "capturedCardsActual",
  },
];

export const NAV_MENU: {
  path?: string;
  label: string;
  permission: string;
  icon?: any;
  iconStyle?: Record<string, string>;
  subMenu?: {
    path?: string;
    label?: string;
    permission?: string;
  }[];
}[] = [
  {
    path: "/smt-dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
    permission: "",
  },

  {
    label: "Machine Services",
    permission: "",
    icon: LucideBanknoteArrowUp,
    path: "/kiosk",
  },
  {
    path: "",
    label: "CIT Services",
    permission: "",
    icon: Boxes,
    subMenu: [
      {
        path: "/collections",
        label: "Collections",
        permission: Permissions.Collection,
      },

      {
        path: "/exchange-services",
        label: "Exchange",
        permission: "",
      },
    ],
  },
  {
    path: "/b2b-services",
    label: "B2B",
    permission: Permissions.B2B,
    icon: MdDashboard,
  },

  {
    path: "/inter-branch-services",
    label: "Inter Branch",
    permission: "",
    icon: ArrowLeftRightIcon,
  },
  // {
  //   label: "Others",
  //   permission: "",
  //   icon: ChevronsRight,
  //   iconStyle: { width: "14px" },
  //   subMenu: [
  //     {
  //       path: "/deliveries",
  //       label: "Deliveries",
  //       permission: Permissions.Delivery,
  //     },
  //     {
  //       path: "/replenishment",
  //       label: "Replenishment",
  //       permission: Permissions.Replenishment,
  //     },
  //     {
  //       path: "/clearance",
  //       label: "Clearance",
  //       permission: Permissions.Clearance,
  //     },
  //   ],
  // },
  {
    label: "Reports",
    icon: MdAllOut,
    permission: Permissions.Report,
    subMenu: [
      {
        path: "/collection-report",
        label: "Daily Cash Collection",
        permission: Permissions.View,
      },
      {
        path: "/delivery-report",
        label: "Daily Cash Delivery",
        permission: Permissions.View,
      },
      {
        path: "/cit-report",
        label: "CIT Services",
        permission: Permissions.View,
      },
      {
        path: "/vault-report",
        label: "Daily Vault",
        permission: Permissions.View,
      },
      {
        path: "/cashier-residuals-report",
        label: "Cashier Residuals",
        permission: Permissions.View,
      },
      {
        path: "/cashier-cassettes-filling-report",
        label: "Cashier Cassettes Filling",
        permission: Permissions.View,
      },
      {
        path: "/cit-field-services-report",
        label: "CIT Field Services",
        permission: Permissions.View,
      },
      {
        path: "/atm-field-service-report",
        label: "ATM Field Service",
        permission: Permissions.View,
      },
      {
        path: "/roster-report",
        label: "Daily Roster",
        permission: Permissions.View,
      },
      {
        path: "/cdm-collection-report",
        label: "CDM Collection",
        permission: Permissions.View,
      },
      {
        path: "/cdm-discrepancies-report",
        label: "CDM Discrepancies",
        permission: Permissions.View,
      },
      {
        path: "/cdm-history-report",
        label: "CDM History",
        permission: Permissions.View,
      },
      {
        path: "/cdm-reconciliation-report",
        label: "CDM Reconciliation",
        permission: Permissions.View,
      },
      {
        path: "/atm-discrepancies-report",
        label: "ATM Discrepancies",
        permission: Permissions.View,
      },
      {
        path: "/atm-history-report",
        label: "ATM History",
        permission: Permissions.View,
      },
      {
        path: "/atm-reconciliation-report",
        label: "ATM Reconciliation",
        permission: Permissions.View,
      },
      {
        path: "/atm-replenishment-report",
        label: "ATM Replenishment",
        permission: Permissions.View,
      },
      {
        path: "/atm-residuals-report",
        label: "ATM Residuals",
        permission: Permissions.View,
      },
    ],
  },
];

export const PREV_DAY_DATE = new Date(
  new Date().setDate(new Date().getDate() - 1),
);

export const NEXT_DAY_DATE = new Date(
  new Date().setDate(new Date().getDate() + 1),
);

export const PREV_5_DAY_DATE = new Date(
  new Date().setDate(new Date().getDate() - 6),
);

// Array of file configurations to process
export const ATTACHMENTS_TO_PROCESS = [
  { key: "signedDeliveryNote" as const, prefix: "Signed_Delivery_Note" },
  { key: "teamLeaderId" as const, prefix: "Team_Leader_Id" },
  { key: "guard1Id" as const, prefix: "Guard_1_Id" },
  { key: "scannedVHR" as const, prefix: "VHR" },
  { key: "driverId" as const, prefix: "Driver_Id" },
  { key: "guard2Id" as const, prefix: "Guard_2_Id" },
];

// Configuration for file fields
export const ATTACHMENT_FIELDS = [
  {
    key: "signedDeliveryNote",
    label: "Signed Delivery Note",
    isRequired: true,
  },
  { key: "scannedVHR", label: "Scanned VHR", isRequired: false },
  { key: "teamLeaderId", label: "Team Leader ID", isRequired: true },
  { key: "guard1Id", label: "Guard 1 ID", isRequired: true },
  { key: "guard2Id", label: "Guard 2 ID", isRequired: false },
  { key: "driverId", label: "Driver ID", isRequired: false },
];

export const PERIODS = [
  { id: "Today", name: "Today" },
  {
    id: "All",
    name: "All",
  },
  { id: "Yesterday", name: "Yesterday" },

  {
    id: "This Week",
    name: "This Week",
  },
  {
    id: "Last Week",
    name: "Last Week",
  },
  {
    id: "This Month",
    name: "This Month",
  },
];

export const SERVICES_LIST = [
  { name: "Kiosk Service", value: "Kiosk Service" },
  { name: "Collection", value: "Collection" },
  { name: "Exchange Service", value: "Exchange Service" },
  { name: "B2B Service", value: "B2B Service" },
];

export const SERVICE_LINK = {
  Replenishment: "/replenishment-detail",
  Clearance: "/clearance-detail",
  "Kiosk Service": "/kiosk-detail",
  Collection: "/collections-detail",
  Delivery: "/deliveries-detail",
  "B2B Service": "/b2b-services-detail",
};

export const BAG_COINS_DENOMINATIONS = [
  {
    label: "AED 1",
    value: "AED 1",
  },
  {
    label: "AED 0.5",
    value: "AED 0.5",
  },
  {
    label: "AED 0.25",
    value: "AED 0.25",
  },
];

export const BOX_COINS_DENOMINATIONS = [
  {
    label: "AED 1",
    value: "AED 1",
  },
  {
    label: "AED 0.5",
    value: "AED 0.5",
  },
  {
    label: "AED 0.25",
    value: "AED 0.25",
  },
  {
    label: "AED 0.1",
    value: "AED 0.1",
  },
  {
    label: "AED 0.05",
    value: "AED 0.05",
  },
  {
    label: "AED 0.01",
    value: "AED 0.01",
  },
];

export const MAX_TOTAL_TIME = 300; // total scan must complete within 300ms
export const MAX_IDLE_TIME = 100; // gap between keys
export const MIN_LENGTH = 3;

export const SEAL_NUMBER_REGEX = /^[a-zA-Z0-9]+$/;
